import { ElementScope, globals, ready, action, mount, unmount, initMenus, registerElements, initForms, initStyles, tryAttachExternalDependencies, BuApi, BU } from "$lib/ui-core";
import { browser } from "$lib/core";

import { Logger } from "$lib/core/js/util/logger";

const G = /** @type { globalThis & { BU: BuApi }} */ (globals);

if (browser) {
	if (!("BU" in G) || !G.BU) {
		G.BU = BU;
	}

	const category = "ElementSetup";
	const setupLogger = new Logger(category);
	Logger.addLogger(category);

	ready(async () => {
		// Skip this logic if using the full web-component version of Baylor UI.
		if (document.querySelector("body[data-auto-attach='true']")) {
			return;
		}

		tryAttachExternalDependencies();

		registerElements();
		
		for (let element of document.querySelectorAll("[data-is]")) {
			if (!(element instanceof HTMLElement)) continue;

			const scopeName = element.dataset.scope ?? "default";
			const type = element.dataset.is;
			const load = element.dataset.load === "true";
			const loadUrl = element.dataset.loadUrl;

			if (type) {
				Logger.addLogger(type);
			}

			setupLogger.debug("Baylor UI Element detected", {
				scopeName,
				type,
				load,
				loadUrl,
			});

			if (!type) {
				setupLogger.warn(`Element type was empty! Skipping...`);
				return;
			}
			const ctor = BU.types?.[type];
			if (ctor) {
				const obj = /** @type {import("$lib/ui-core/public").IMountable} */ (new ctor({ target: element }));

				try {
					if (load && typeof obj.load !== "undefined") {
						setupLogger.debug(`Element '${type}' is loading a template...`);
						await obj.load(loadUrl);
						setupLogger.debug(`Element '${type}' template loading complete.`);
					} else {
						setupLogger.trace(`Element '${type}' does not need to load a template.`)
					}
					setupLogger.debug(`Element '${type}' initializing`, obj.target ?? element);
					obj.init();
					setupLogger.debug(`Element '${type}' initialization complete.`, obj.target ?? element);
				} catch (error) {
					setupLogger.error("Failed element setup", {
						element,
						scope: scopeName,
						type,
						load,
					});
					throw error;
				}

				const scope = BU.scopes[scopeName] = BU.scopes[scopeName] ?? new ElementScope(scopeName);
				scope.add(obj);
			} else {
				setupLogger.warn(`Element '${type}' has no constructor registered! Skipping...`);
			}
		}

		initMenus();
		initForms();
		initStyles();

	});
}